import {
  useMutation,
  type QueryKey,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';
import { Nullable } from '@/types/helper';

export interface EditFileClientRequest {
  fileId: number;
  clientIds: number[];
  newClients: {
    name?: Nullable<string>;
    email?: Nullable<string>;
    company?: Nullable<string>;
    phone?: Nullable<string>;
    position?: Nullable<string>;
    department?: Nullable<string>;
    memo?: Nullable<string>;
  }[];
}

export const editFileClient = ({
  fileId,
  clientIds,
  newClients,
}: EditFileClientRequest) => {
  return api.put<ApiResponse<undefined>>('/file/client', {
    fileId,
    clientIds,
    newClients,
  });
};

const useEditFileClient = <TError = AxiosError<ApiErrorResponse>>(
  options?: UseMutationOptions<
    AxiosResponse<ApiResponse<undefined>>,
    TError,
    EditFileClientRequest,
    QueryKey
  >,
): UseMutationResult<
  AxiosResponse<ApiResponse<undefined>>,
  TError,
  EditFileClientRequest,
  QueryKey
> => {
  return useMutation(editFileClient, {
    ...options,
  });
};

export default useEditFileClient;
